import { useEffect, useState } from 'react';

/**
 * 断点判定。
 *
 * 只服务一个场景：窄屏把侧边导航折叠成抽屉。
 * 断点集合刻意保持很小，避免「每个组件各有一套断点」。
 */
export const BREAKPOINTS = {
  /** 手机竖屏 */
  sm: 640,
  lg: 1024,
} as const;

export type BreakpointName = 'mobile' | 'tablet' | 'desktop';

function nameOf(width: number): BreakpointName {
  if (width < BREAKPOINTS.sm) return 'mobile';
  if (width < BREAKPOINTS.lg) return 'tablet';
  return 'desktop';
}

function useViewportWidth(): number {
  const [width, setWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    let frame = 0;
    const onResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setWidth(window.innerWidth));
    };
    window.addEventListener('resize', onResize);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', onResize);
    };
  }, []);
  return width;
}

export function useBreakpoint() {
  const width = useViewportWidth();
  return {
    width,
    name: nameOf(width),
    isMobile: width < BREAKPOINTS.sm,
    isTablet: width >= BREAKPOINTS.sm && width < BREAKPOINTS.lg,
    isDesktop: width >= BREAKPOINTS.lg,
  };
}
